import React from 'react';
import PropTypes from 'prop-types';
import { Tooltip } from '@mui/material';
import InfoOutlined from '@mui/icons-material/InfoOutlined';

const InfoTooltip = (props) => {
  const { message } = props;
  return (
    <Tooltip title={message} color="disabled" leaveDelay={100} placement="top">
      <InfoOutlined />
    </Tooltip>
  );
};

InfoTooltip.propTypes = {
  message: PropTypes.string.isRequired,
};

export default InfoTooltip;
